import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Renderer2 } from '@angular/core';
import { DateAdapter, MatDateFormats, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatCalendar, MatCalendarHeader, MatDatepickerContent, MatDatepickerIntl, MatDateSelectionModel } from '@angular/material/datepicker';
import { NebulaDatepickerComponent } from './nebula-datepicker.component';

@Component({
  selector: 'nebula-datepicker-header',
  templateUrl: './nebula-datepicker-header.component.html',
  styleUrls: ['./nebula-datepicker-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NebulaDatepickerHeaderComponent extends MatCalendarHeader<Date> {
  public optVisibility: Array<boolean> = [];

  constructor(
    intl: MatDatepickerIntl,
    calendar: MatCalendar<Date>,
    private dateAdapter: DateAdapter<Date>,
    @Inject(MAT_DATE_FORMATS) dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef,
    private datePickerContent: MatDatepickerContent<Date>,
    public nebulaDatepicker: NebulaDatepickerComponent,
    private matDateSelectionModel: MatDateSelectionModel<Date>,
    renderer: Renderer2,
  ) {
    super(intl, calendar, dateAdapter, dateFormats, cdr);

    this.updateButtonStates(this.calendar.selected as Date);
    calendar.selectedChange.subscribe((d: Date) => {
      this.updateButtonStates(d);
    });

    if (this.nebulaDatepicker.options.length > 0) {
      renderer.addClass(this.datePickerContent._elementRef.nativeElement, 'extended');
    }
  }

  updateButtonStates(selected: Date) {
    this.optVisibility = this.nebulaDatepicker.options.map(opt => {
      return this.dateAdapter.sameDate(selected, opt.dateFn(this.dateAdapter));
    });
  }

  setNthOpt(n: number) {
    this.matDateSelectionModel.add(this.nebulaDatepicker.options[n].dateFn(this.dateAdapter) as Date);
    this.datePickerContent.datepicker.close();
  }
}
